import { inject, Injectable } from '@angular/core';
import { DailyRoute } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { EditedStatus, UpdateCustomEditedRouteBody } from 'src/app/pages/custom-route/shared/planner/components/edit-route/interfaces/edit-route.interface';
import { CustomRouteResponseCompleted } from 'src/app/pages/custom-route/interfaces/custom-route.response';
import { catchError, map, of, tap } from 'rxjs';
import { isNotSuccess, validateRoute } from './guards/custom-route.guard';
import dayjs from "dayjs";

type Result = { is_successful: true } | { is_successful: false; reason: string };

@Injectable({ providedIn: 'root' })

export class AddItemToCustomRouteService {
    private _route = inject(CustomRouteService);

    addItem(args: any){
        const route = this._route.customRouteData();
        const token = this._route.token();

        const ctx = validateRoute(route, token, args?.day);
        if (isNotSuccess(ctx))
            return of<Result>(ctx);

        const dayIndex = args.day - 1;
        const dayRoute: DailyRoute = route.dailyRoutes[dayIndex];
        const date = dayjs(dayRoute.date)?.format('YYYY-MM-DD');

        const point = {
            id: args?.element_id,
            title: args?.found_name,
            type: args?.type,
            status: EditedStatus.ADDED,
            startDate: new Date(`${date}T${args?.hour}:00`)
        };

        const mappedPoints = dayRoute.points?.map(point => ({
            id: point.id,
            title: point.title,
            type: point?.type,
            startDate: point?.startDate
        }))

        const currentDayPoint = [...mappedPoints, point];
        currentDayPoint.sort((a: any, b: any) => a.startDate - b.startDate);
        const points: any = currentDayPoint?.map(point => ({
            ...point,
            startDate: dayjs(point.startDate)?.format('YYYY-MM-DDTHH:mm:ss')
        }))

        const payload: UpdateCustomEditedRouteBody = { date, token, points };
        return this._route.updateCustomRouteData(payload).pipe(
            tap((res: CustomRouteResponseCompleted | any) => {
                if (res.error)
                    throw new Error(res.error?.[0]?.motive)
                
                this._route.updateDailyRoute(res, dayIndex);
            }),
            map((): Result => ({ 
                is_successful: true 
            })),
            catchError((error) => {
                return of<Result>({ 
                    is_successful: false, 
                    reason: error?.message ?? 'No se pudo actualizar la ruta' 
                })
            })
        );
    }
}